import { useMemo } from 'react';
import PropTypes from 'prop-types';
// hooks
import useGlobalTimer from '../hooks/useGlobalTimer';

// ----------------------------------------------------------------------

export default function BreakTimer({ breakStart, format = 'full' }) {
  // Use global timer - single interval for all instances
  const currentTime = useGlobalTimer();

  // Calculate elapsed time based on global timer
  const { hours, minutes, seconds } = useMemo(() => {
    if (!breakStart) {
      return { hours: 0, minutes: 0, seconds: 0 };
    }

    let startTime = Date.parse(breakStart);

    if (startTime > currentTime) {
      startTime = currentTime;
    }

    const time = currentTime - startTime;

    return {
      hours: Math.floor((time / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((time / 1000 / 60) % 60),
      seconds: Math.floor((time / 1000) % 60),
    };
  }, [breakStart, currentTime]);

  // Format time with leading zeros
  const formatTime = (value) => (value < 10 ? `0${value}` : value);

  if (format === 'compact') {
    return `${formatTime(hours)}:${formatTime(minutes)}:${formatTime(seconds)}`;
  }

  return (
    <>
      {formatTime(hours)}:{formatTime(minutes)}:{formatTime(seconds)}
    </>
  );
}

BreakTimer.propTypes = {
  breakStart: PropTypes.string,
  format: PropTypes.oneOf(['full', 'compact']),
};
